import React from "react";
import Notification from "../../_rc-notification-3.0.0";
import Icon from "../icon";

let defaultDuration = 2;
let defaultTop;
let messageInstance;
let key = 1;
let prefixCls = "ant-message";
function noop() {}

function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }
  Notification.newInstance(
    {
      prefixCls,
      transitionName: "move-up",
      style: { top: defaultTop } // 覆盖原来的样式
    },
    instance => {
      if (messageInstance) {
        callback(messageInstance);
        return;
      }
      messageInstance = instance;
      callback(instance);
    }
  );
}

function notice(content, duration = defaultDuration, type, onClose) {
  onClose = onClose || noop;
  let iconType = {
    info: "info-circle",
    success: "check-circle",
    error: "cross-circle",
    warning: "exclamation-circle",
    loading: "loading"
  }[type];

  const target = key++;
  getMessageInstance(instance => {
    instance.notice({
      key: target,
      duration,
      style: {},
      content: (
        <div className={`${prefixCls}-custom-content ${prefixCls}-${type}`}>
          <Icon type={iconType} />
          <span>{content}</span>
          <div
            className={`${prefixCls}-custom-close`}
            onClick={() => {
              if (messageInstance) {
                messageInstance.removeNotice(target);
              }
            }}
          >
            <Icon type="cross-circle" />
          </div>
        </div>
      ),
      onClose
    });
  });
  return () => {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };
}

export default {
  info(content, duration, onClose) {
    return notice(content, duration, "info", onClose);
  },
  success(content, duration, onClose) {
    return notice(content, duration, "success", onClose);
  },
  error(content, duration, onClose) {
    return notice(content, duration, "error", onClose);
  },
  // Departed usage, please use warning()
  warn(content, duration, onClose) {
    return notice(content, duration, "warning", onClose);
  },
  warning(content, duration, onClose) {
    return notice(content, duration, "warning", onClose);
  },
  loading(content, duration, onClose) {
    return notice(content, duration, "loading", onClose);
  },
  config(options) {
    if ("top" in options) {
      defaultTop = options.top;
    }
    if ("duration" in options) {
      defaultDuration = options.duration;
    }
    if ("prefixCls" in options) {
      prefixCls = options.prefixCls;
    }
  },
  destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};



// WEBPACK FOOTER //
// ./_antd1.11.2/message/index.jsx